module.exports = __webpack_public_path__ + "img/my-account-mobile-en.788c4223.jpg";